import axios from "axios";

export const PAYWALL_EVENT = "tutor:paywall";

export function firePaywall(detail) {
  window.dispatchEvent(new CustomEvent(PAYWALL_EVENT, { detail: detail || {} }));
}

export function errMsg(e, fallback = "Something went wrong.") {
  const d = e?.response?.data?.detail ?? e?.detail ?? e?.message;
  if (!d) return fallback;
  return typeof d === "string" ? d : d.message || fallback;
}

// For raw fetch() responses: returns true when the 402 was handled.
export async function handleFetchPaywall(resp) {
  if (resp.status !== 402) return null;
  const e = await resp.json().catch(() => ({}));
  const detail = typeof e.detail === "object" ? e.detail : { message: e.detail || "Upgrade required." };
  firePaywall(detail);
  return detail;
}

// Axios interceptor: opens the paywall on any 402 from tutor APIs.
export function installPaywallInterceptor() {
  const id = window.__axiosPaywallId;
  if (id !== undefined) return () => {};
  const interceptorId = axios.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 402) {
        const d = err.response.data?.detail;
        firePaywall(typeof d === "object" ? d : { message: d });
        err.paywalled = true;
      }
      return Promise.reject(err);
    }
  );
  window.__axiosPaywallId = interceptorId;
  return () => { axios.interceptors.response.eject(interceptorId); delete window.__axiosPaywallId; };
}
